import { Components } from '.generated/templates/Feature.Components.model';
import { Data } from '.generated/templates/Feature.Data.model';
import { Routes } from '.generated/templates/Project.Routes.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
import LinkA11yWrapper from 'components/helpers/LinkA11yWrapper';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { pageNavigationDataLayerHandler } from 'lib/util/gtm-datalayer';

export type SocialLinks = Sitecore.Override.ItemEx & Data.SocialLinks.Fields.SocialLinks;
export type GenericPage = Sitecore.Override.ItemEx & Routes.Fields.GenericPage;
export type NavigationLink = Sitecore.Override.ItemEx & Data.Navigation.Fields.NavigationLink;
export type PageOrLink = GenericPage | NavigationLink;

type ritnnavigationFooter = Sitecore.Override.ItemEx &
  Data.Navigation.Fields.NavigationFooter & { children?: NavigationLink[] };
type ritnfooterOrLink = (NavigationLink | ritnnavigationFooter) & { templateId: string };

export type RitnFooterProps = {
  ritnfields?: Components.Site.Fields.Footer & {
    footerLinks?: PageOrLink[];
    socialLinks?: SocialLinks[];
    children?: ritnfooterOrLink[] & {
      children?: NavigationLink[];
    };
  };
};
const RitnFooter = ({ ritnfields }: RitnFooterProps): JSX.Element => {
  if (!ritnfields) {
    return <MissingDataSource />;
  }
  const footerContainer = classnames(
    'relative',
    'py-6',
    'px-4',
    'md:py-10',
    'overflow-hidden',
    'bg-blue-navy',
    'text-white',
    'text-center'
  );
  const footerLinkList = ritnfields.fields?.footerLinks?.map((item) => {
    const navitem = item.fields.navigationItemLink ? (item as NavigationLink) : null;
    const pageitem = !item.fields.navigationItemLink ? (item as GenericPage) : null;
    const linkfield = navitem
      ? navitem.fields.navigationItemLink
      : {
          value: {
            href: pageitem?.url,
            text:
              pageitem?.fields.navigationTitle.value ||
              pageitem?.fields.pageTitle.value ||
              pageitem?.name,
          },
        };
    return (
      <LinkA11yWrapper
        key={item.id}
        className={classnames(
          'underline',
          'after:pl-5',
          'after:content-["|"]',
          'after:pr-5',
          'last:after:content-[""]'
        )}
        editable={false}
        field={linkfield}
        onGtmPush={(e) => {
          pageNavigationDataLayerHandler(e);
        }}
      />
    );
  });
  return (
    <div data-component="authorable/site/footer">
      <div className={footerContainer}>
        <div
          className={classnames(
            'max-w-screen-2xl',
            'mx-auto',
            'lg:grid',
            'grid-cols-2',
            'md:gap-5',
            'lg:gap-7',
            'text-sm'
          )}
        >
          <div className={classnames('text-left', 'sm:mb-1')}>{footerLinkList}</div>
          <div className={classnames('text-left', 'lg:text-right')}>
            <p>
              {ritnfields?.fields?.copyright.value.replaceAll(
                '@year',
                new Date().getFullYear().toString()
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RitnFooter;
